import {CommentIcon} from '@primer/octicons-react'
import {Tool, ToolPrimaryContent} from './tool/Tool'
import styles from './ThinkingBlock.module.css'

export type ThinkingBlockProps = {
  reasoningText: string
  isInGroup?: boolean
}

export function ThinkingBlock({reasoningText, isInGroup}: ThinkingBlockProps) {
  return (
    <Tool
      title="Thinking"
      isError={false}
      collapsible
      isOpenOverride
      bordered={false}
      isInGroup={isInGroup}
      toolHeaderProps={{leadingVisual: <CommentIcon size={16} aria-hidden="true" />}}
    >
      <div className={styles.thinkingContent}>
        <ToolPrimaryContent language="markdown" markdown={reasoningText} />
      </div>
    </Tool>
  )
}
